import {useFormik} from 'formik';
import * as Yup from 'yup';
import {useConsentsDocuments, CreateConsentDocumentDTO} from '../../../entities';
import {AxiosError} from 'axios';

type UseAddConsentDocumentFormProps = {
  setOpen: (open: boolean) => void;
};

export const useAddConsentDocumentForm = ({setOpen}: UseAddConsentDocumentFormProps) => {
  const {createDocumentMutation} = useConsentsDocuments();

  const onSubmit = async (values: CreateConsentDocumentDTO) => {
    try {
      await createDocumentMutation.mutateAsync(values);
      setOpen(false);
    } catch (error: any) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      title: '',
      displayText: '',
      isDistinguished: false,
      isMandatory: false,
      order: 1,
    },
    validationSchema: Yup.object({
      title: Yup.string().min(1, 'Название документа обязательно').required('Название документа обязательно'),
      displayText: Yup.string().min(1, 'Текст для показа обязателен').required('Текст для показа обязателен'),
      isDistinguished: Yup.boolean(),
      isMandatory: Yup.boolean(),
      order: Yup.number().integer('Порядок должен быть целым числом').min(1, 'Порядок должен быть больше 0'),
    }),
    onSubmit,
  });

  return {
    values: formik.values,
    errors: formik.errors,
    touched: formik.touched,
    handleChange: formik.handleChange,
    handleBlur: formik.handleBlur,
    setFieldValue: formik.setFieldValue,
    resetForm: formik.resetForm,
    submitForm: formik.submitForm,
    isLoading: createDocumentMutation.isPending,
    submitError: createDocumentMutation.error
      ? (createDocumentMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
  };
};
